import { gql } from '@apollo/client';

export default gql`
  mutation UserSetupTwoFactor {
    userSetupTwoFactor(input: {}) {
      qrCode
      secret
    }
  }
`;
